import { render, staticRenderFns } from "./HelpFooter.vue?vue&type=template&id=2b02d3db"
import script from "./HelpFooter.vue?vue&type=script&lang=ts"
export * from "./HelpFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b02d3db')) {
      api.createRecord('2b02d3db', component.options)
    } else {
      api.reload('2b02d3db', component.options)
    }
    module.hot.accept("./HelpFooter.vue?vue&type=template&id=2b02d3db", function () {
      api.rerender('2b02d3db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/upload_tabs/HelpFooter.vue"
export default component.exports